var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb-wrapper clearfix"},[_c('el-breadcrumb',{staticClass:"left",attrs:{"separator":"/"}},[_c('el-breadcrumb-item',[_vm._v(_vm._s(this.$route.name))])],1),_vm._v(" "),_c('div',{staticClass:"right"},[_vm._t("button")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-351590f1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/base/breadcrumb/breadcrumb.vue
// module id = B/2y
// module chunks = 80